import React, { createContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { singIn, logout } from "../action/authActions";
import { resetStore } from "../action/action";
import { getUser } from "../action/authActions";
// import jwt from "jsonwebtoken";
import { jwtDecode } from "jwt-decode";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

function resolveShareNavigation(sharePath, shareId, buyVotes) {
  if (!sharePath || !shareId) return null;
  if (sharePath === "tournament") return `/viewTournament/${shareId}`;
  if (sharePath === "league") return `/viewLeague/${shareId}`;
  if (sharePath === "club") return `/viewClub/${shareId}`;
  if (sharePath === "competition") {
    return buyVotes === "1"
      ? `/competitions/${shareId}?buyVotes=1`
      : `/competitions/${shareId}`;
  }
  return null;
}

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const [searchParams] = useSearchParams();

  const shareLinkToken = searchParams.get("shareToken");
  const sharePath = searchParams.get("path");
  const shareId = searchParams.get("id");
  const buyVotes = searchParams.get("buyVotes");

  // console.log(
  //   shareLinkToken,
  //   sharePath,
  //   shareId,
  //   "share data retrived from share link",
  // );

  // "";

  useEffect(() => {
    const path = window.location.pathname;
    const isAdmin = path.split("/")[1];

    let token;

    if (isAdmin == "admin") {
      token = localStorage.getItem("mynetgoals.com-token-admin");
    } else {
      token = localStorage.getItem("mynetgoals.com-token");
    }

    const applyShareToken = (shareToken) => {
      const user = jwtDecode(shareToken);
      localStorage.setItem("mynetgoals.com-token", shareToken);
      dispatch(singIn(shareToken));
      dispatch({ type: "SAVE_LOGGED_USER", payload: user });
      if (!user?.device_id) {
        localStorage.removeItem("mynetgoals.com-userData");
        dispatch(getUser(shareToken, user.id));
      }
      return user;
    };

    if (shareLinkToken && shareId && sharePath) {
      try {
        applyShareToken(shareLinkToken);
      } catch {
        // invalid share token — fall through with existing session if any
      }

      const shareTarget = resolveShareNavigation(sharePath, shareId, buyVotes);
      if (shareTarget) {
        navigate(shareTarget, { replace: true });
      }
    } else if (token) {
      const user = jwtDecode(token);
      dispatch(singIn(token));
      dispatch({ type: "SAVE_LOGGED_USER", payload: user });

      if (!user?.device_id) {
        localStorage.removeItem("mynetgoals.com-userData");
        dispatch(getUser(token, user.id));
      }
    }

    setLoading(false);
  }, [dispatch, shareLinkToken, sharePath, shareId, buyVotes, navigate]);

  const authLogin = (token) => {
    localStorage.setItem("mynetgoals.com-token-admin", token);
    dispatch(singIn(token));
  };

  const authLoginUser = (token) => {
    localStorage.setItem("mynetgoals.com-token", token);
    try {
      const payload = jwtDecode(token);
      // Real account login — drop leftover guest trial blob
      if (!payload?.device_id) {
        localStorage.removeItem("mynetgoals.com-userData");
      }
    } catch (e) {
      // ignore decode errors; token still stored
    }
    dispatch(singIn(token));
  };

  const authLogout = (admin = false) => {
    if (admin) {
      localStorage.removeItem("mynetgoals.com-token-admin");
      dispatch(logout());
      dispatch(resetStore());
      return;
    }
    localStorage.removeItem("mynetgoals.com-token");
    localStorage.removeItem("mynetgoals.com-userData");
    dispatch(logout());
    dispatch(resetStore());
  };

  if (loading) {
    return;
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login: authLogin,
        logout: authLogout,
        loginUser: authLoginUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return React.useContext(AuthContext);
};
